import { render, staticRenderFns } from "./BaseLandingWithoutTabs.vue?vue&type=template&id=7ef1c0e9&scoped=true"
import script from "./BaseLandingWithoutTabs.vue?vue&type=script&lang=js"
export * from "./BaseLandingWithoutTabs.vue?vue&type=script&lang=js"
import style0 from "./BaseLandingWithoutTabs.vue?vue&type=style&index=0&id=7ef1c0e9&prod&lang=scss&scoped=true"
import style1 from "./BaseLandingWithoutTabs.vue?vue&type=style&index=1&id=7ef1c0e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_css-loader@6.11.0_webpack@5.105.2__lodash@4_64be4d9407eb667fe9a1e2476327747d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef1c0e9",
  null
  
)

export default component.exports